import { render, staticRenderFns } from "./crudPHPCode.vue?vue&type=template&id=1a11e310&"
import script from "./crudPHPCode.vue?vue&type=script&lang=js&"
export * from "./crudPHPCode.vue?vue&type=script&lang=js&"
import style0 from "./crudPHPCode.vue?vue&type=style&index=0&id=1a11e310&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports